module.exports = __webpack_public_path__ + "img/02.43a52ee.png";